
  import { Vue, Component, Prop } from "vue-property-decorator";
  import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";
  import DropdownOption from "@/entities/DropdownOption";

  @Component({
    components: {
      DropdownFilter,
    },
  })
  export default class RateUnitSelect extends Vue {
    @Prop({ default: "week", type: String}) value!: string;
    @Prop({ default: true, type: Boolean }) withBorder!: boolean;
     @Prop({ type: String, default: "" }) readonly getcontainerStyle?: string;

    get mappedValue(): DropdownOption[] {
      const option = this.rateUnits.find(({ id }) => id === this.value)!;
      return [option];
    }

    rateUnits: DropdownOption[] = [
      { id: "hour", name: "Hourly" },
      { id: "day", name: "Daily" },
      { id: "week", name: "Weekly" },
      { id: "month", name: "Monthly" },
    ];

    handleInput(val: DropdownOption[]): void {
      if (!val.length) {
        return;
      }
      
      this.$emit("input", val[0].id);
    }
  }
